import { NgModule } from '@angular/core';

import { routing } from './hack-results.routing';
import { HackResultsComponent } from './hack-results.component';
import { CommonModule } from '@angular/common';
import { HackResultsViewerModule } from '../shared/components/hack-results-viewer/hack-results-viewer.module';


export class HackResultsModule { }



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/hack-results/hack-results.module.ts